module.exports = __webpack_public_path__ + "img/boss-bf-3-flanger.e57af6cf.jpg";